import httpRequest from "@/utils/api";
import type {
  TutorCertificationStatus,
  TutorCertificationTeacherDetail,
  TutorCertificationTeacherListData,
  TutorProfileReviewActionPayload,
  TutorProfileReviewApplication,
  TutorProfileReviewApplicationListData,
  TutorProfileReviewApplicationStatus,
  TutorTeachingStatus,
} from "@/types/admin/tutorProfileReview";

enum API {
  certificationTeachers = "/admin/tutor/certification-teachers",
  certificationTeacher = "/admin/tutor/certification-teachers/:profileId",
  certificationTeacherSuspend = "/admin/tutor/certification-teachers/:profileId/suspend",
  certificationTeacherResume = "/admin/tutor/certification-teachers/:profileId/resume",
  certificationTeacherRevoke = "/admin/tutor/certification-teachers/:profileId/revoke",
  profileReviews = "/admin/tutor/profile-reviews",
  profileReview = "/admin/tutor/profile-reviews/:applicationId",
  approve = "/admin/tutor/profile-reviews/:applicationId/approve",
  reject = "/admin/tutor/profile-reviews/:applicationId/reject",
  requestRevision = "/admin/tutor/profile-reviews/:applicationId/request-revision",
}

export const getAdminTutorCertificationTeachersAPI = (params: {
  page: number;
  limit: number;
  tenantId?: number | null;
  certificationStatus?: TutorCertificationStatus | "";
  teachingStatus?: TutorTeachingStatus | "";
}) => {
  const queryParams: {
    page: number;
    limit: number;
    tenantId?: number;
    certificationStatus?: TutorCertificationStatus;
    teachingStatus?: TutorTeachingStatus;
  } = {
    page: params.page,
    limit: params.limit,
  };
  if (params.tenantId) {
    queryParams.tenantId = params.tenantId;
  }
  if (params.certificationStatus) {
    queryParams.certificationStatus = params.certificationStatus;
  }
  if (params.teachingStatus) {
    queryParams.teachingStatus = params.teachingStatus;
  }
  return httpRequest.get<TutorCertificationTeacherListData>({
    url: API.certificationTeachers,
    params: queryParams,
  });
};

export const getAdminTutorCertificationTeacherAPI = (profileId: number) => {
  return httpRequest.get<TutorCertificationTeacherDetail>({
    url: API.certificationTeacher.replace(":profileId", profileId.toString()),
  });
};

export const suspendAdminTutorCertificationTeacherAPI = (
  profileId: number,
  payload: TutorProfileReviewActionPayload,
) => {
  return httpRequest.post<TutorCertificationTeacherDetail>({
    url: API.certificationTeacherSuspend.replace(":profileId", profileId.toString()),
    data: payload,
  });
};

export const resumeAdminTutorCertificationTeacherAPI = (
  profileId: number,
  payload: TutorProfileReviewActionPayload,
) => {
  return httpRequest.post<TutorCertificationTeacherDetail>({
    url: API.certificationTeacherResume.replace(":profileId", profileId.toString()),
    data: payload,
  });
};

export const revokeAdminTutorCertificationTeacherAPI = (
  profileId: number,
  payload: TutorProfileReviewActionPayload,
) => {
  return httpRequest.post<TutorCertificationTeacherDetail>({
    url: API.certificationTeacherRevoke.replace(":profileId", profileId.toString()),
    data: payload,
  });
};

export const getAdminTutorProfileReviewsAPI = (params: {
  page: number;
  limit: number;
  status?: TutorProfileReviewApplicationStatus | "";
  tenantId?: number | null;
}) => {
  const queryParams: {
    page: number;
    limit: number;
    status?: TutorProfileReviewApplicationStatus;
    tenantId?: number;
  } = {
    page: params.page,
    limit: params.limit,
  };
  if (params.status) {
    queryParams.status = params.status;
  }
  if (params.tenantId) {
    queryParams.tenantId = params.tenantId;
  }
  return httpRequest.get<TutorProfileReviewApplicationListData>({
    url: API.profileReviews,
    params: queryParams,
  });
};

export const getAdminTutorProfileReviewAPI = (applicationId: number) => {
  return httpRequest.get<TutorProfileReviewApplication>({
    url: API.profileReview.replace(":applicationId", applicationId.toString()),
  });
};

export const approveAdminTutorProfileReviewAPI = (
  applicationId: number,
  payload: TutorProfileReviewActionPayload,
) => {
  return httpRequest.put<TutorProfileReviewApplication>({
    url: API.approve.replace(":applicationId", applicationId.toString()),
    data: payload,
  });
};

export const rejectAdminTutorProfileReviewAPI = (
  applicationId: number,
  payload: TutorProfileReviewActionPayload,
) => {
  return httpRequest.put<TutorProfileReviewApplication>({
    url: API.reject.replace(":applicationId", applicationId.toString()),
    data: payload,
  });
};

export const requestRevisionAdminTutorProfileReviewAPI = (
  applicationId: number,
  payload: TutorProfileReviewActionPayload,
) => {
  return httpRequest.put<TutorProfileReviewApplication>({
    url: API.requestRevision.replace(":applicationId", applicationId.toString()),
    data: payload,
  });
};
